import React, { useContext, useEffect, useState, useRef } from "react";
import HeaderRoutes from "../../components/HeaderRoutes/HeaderRoutes";
import { Box, Card, Grid, MenuItem, TextField, } from "@mui/material";
import AuthContext, { reloadUserData } from "../../context/AuthContext";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import { useForm } from "react-hook-form";
import { useSnackbar } from "notistack";
import ApiService from "../../functions/apiService";
import ProfileSocialMedia from "../../components/Profile/ProfileSocialMedia";
import Error from "../../components/Error/Error";
import { useSelector } from "react-redux";
import { setMyBalance } from "../../store/myShiftsReducer";
import { useDispatch } from "react-redux";
import MyBalanceTable from "../../components/MyShifts/MyBalanceTable";
import '../Certificates/certificates.css'
import { Col, Row, Modal } from "react-bootstrap";
import moment from "moment";
import { toast } from 'react-toastify';
import CalendarLoader from "../../components/Calendar/CalendarLoader";


const UserCertificates = (props) => {
  const [certificates, setCertificates] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [certDetail, setCertDetail] = useState('')
  const [certId, setCertId] = useState('')
  const inputFile = useRef(null);
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false)

  const loadCertificates = () => {
    ApiService.get(`/get-my-certificates`)
      .then(({ data }) => {
        setCertificates(data?.data);
      })
      .catch(() => {
      })
  }

  const DaysToExpiration = (expirationDate) => {
    const today = moment();
    const expiry = moment(expirationDate);
    const difference = expiry.diff(today, 'days');
    return difference;
  };

  const ExpiryValue = (expirationDate) => {
    if (!expirationDate) {
      return 'Valid';
    }
    const daysLeft = DaysToExpiration(expirationDate);
    if (daysLeft > 10) {
      return 'Valid';
    } else if (daysLeft >= 0 && daysLeft <= 10) {
      return 'Expiring';
    } else {
      return 'Expired';
    }
  };

  const isPdf = (url) => {
    let urlArr = url.split('.')
    if (urlArr[urlArr.length - 1] == 'pdf') {
      return true
    }
    else {
      return false
    }
  }

  const onImageChange = async (event) => {
    setLoading(true)
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];

      var bodyFormData = new FormData();
      bodyFormData.append('Certificate_id', certId);
      bodyFormData.append('Emp_Code', user.Emp_Code);
      bodyFormData.append('file', file);
      ApiService.post('/upload-employee-certificate', bodyFormData)
        .then((data) => {
          setCertId('')
          toast.success(data.message)
          loadCertificates()
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false)
          if (error.status == 422) {
            Object.keys(error.data.errors).map((err) => (
              toast.error(error.data.errors[err][0])
            ))
          }
          else {
            toast.error(error.data.message)
          }
        })
    }
  };

  useEffect(() => {
    loadCertificates()
  }, [])

  return (
    <>
      <Card className="shadow p-3 my-3">
        <h6 className="fs-5 fw-600 my-2">Certificates</h6>
        <Box className="my-2">
          {!certificates || certificates.length == 0 ?
            <>
              <label className="form-check-label">
                There are currently no certificates available.
              </label>
              <div className='inner-box'>
                <img src='/images/blur-logo.png' style={{ width: 150, height: 'auto' }} />
              </div>
            </>
            :
            loading == true ?
              <CalendarLoader />
              :
              <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: 10, gap: '10px 0px' }}>
                {certificates.map((cert) => (
                  <Col md={4} className="p-2">
                    <div className="certificate-box">
                      <div className="certificate"
                        style={{ backgroundImage: cert?.Certificate_Url && !isPdf(cert?.Certificate_Url) && 'url()' }} >
                        {cert.Certificate_Url ?
                          isPdf(cert?.Certificate_Url)
                            ?
                            <a target="blank" href={cert.Certificate_Url}>
                              <img src='/images/pdf.png' className="center-img"
                                style={{ position: 'relative', top: 0, width: 30, height: 'auto' }} />
                            </a>
                            :
                            <>
                              <img src={cert.Certificate_Url} style={{ height: 190 }} />
                              <div className="view-img" style={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                <a target="blank" href={cert.Certificate_Url}>
                                  <img src='/images/pdf.png' style={{ width: 25, height: 'auto' }} />
                                </a>
                              </div>
                            </>
                          :
                          <>
                            <input type="file" name="backgroundImage" ref={inputFile} style={{ display: 'none' }} onChange={onImageChange} />
                            <img src='/images/upload.png' className="center-img" onClick={() => {
                              setCertId(cert?.Certificate_id)
                              inputFile?.current?.click()
                            }} />
                          </>
                        }
                      </div>
                      <div className='title mt-2'>{cert?.certificate?.Name}</div>
                      <Row className="w-100 m-auto mt-1">
                        <Col md={6} className="p-0">
                          <div className="cert-date">Expiration Date</div>
                          <div className="cert-date">{cert?.Expiration_Date ? moment(cert?.Expiration_Date).format('MM-DD-YYYY') : 'No expiry'}</div>
                        </Col>
                        <Col md={4} className="p-0 d-flex" style={{ alignItems: 'center', justifyContent: 'flex-end' }}>
                          <span className={`certificate-status ${ExpiryValue(cert?.Expiration_Date)} p-1`}>
                            {ExpiryValue(cert?.Expiration_Date)}
                          </span>
                        </Col>
                        <Col md={2} className="p-0 d-flex" style={{ justifyContent: 'flex-end' }}>
                          <div className="view-cert" onClick={() => {
                            setShowModal(true)
                            setCertDetail(cert)
                          }}>
                            <img src='/images/view.png' />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ))}
              </div>
          }
        </Box>
      </Card>

      <Modal show={showModal} onHide={() => {
        setShowModal(false)
        setCertDetail('')
      }}>
        <Modal.Header closeButton>
          <Modal.Title>{certDetail?.certificate?.Name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='title'>Training History</div>
          <div style={{ color: '#555555' }} className="mt-2">
            {certDetail?.Training_History || 'No traning history added'}
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
export default UserCertificates;